<template>
    <div>
        <grid v-model="data" :descriptions="descriptions" :grouping="grouping"></grid>
        <van-button type="primary" size="large" @click="save">保存</van-button>
    </div>
</template>
<script>
    import fieldDescriptionService from '../service/fieldDescriptionService';
    import dataService from '../service/dynamicentity/dataService';
    import Grid from "./Grid";
    import {Button,Toast} from "vant";
	import {gridScript} from "../mixin/gridScript";


    const _ = require('lodash');

    export default {
		mixins: [gridScript],
        data: function () {
            return {
                descriptions: [],
                data: {},
				param:{}
            }
        },
        props: {
            metaId: {
                type: String,
                default:''
            },
			 tableName: {
			    type: String,
			    default:''
			},
            dataId: {
                type: String,
                default: ''
            },
            hiddenFields:{
                type: Array,
                default: () => []
            },
            grouping: {
                type: Boolean,
                default: true
            },
			defaultValue: {
			    type: Object,
			    default: null
			}
        },
        created: async function () {
			window.setReadonly = this.setReadonly;
			window.hide = this.hide;
			window.asyncRequest = this.asyncRequest;
			window.setValue = this.setValue;
			if(this.tableName || this.tableName == "0") {
				let resp = await fieldDescriptionService.getGridByTableName(this.tableName);
				if (resp.data.Status === "1") {
				    this.descriptions = resp.data.Data.map(item => Object.assign(item, {readonly: item.readOnly})).filter(item =>!this.hiddenFields.some(ele=>ele===item.fieldName));
					this.descriptions = this.descriptions.filter(item => item.classify && item.classify != '');
					if (this.dataId){
				        this.descriptions.forEach(item => {
				            if(item.writeInCreation) {
				                item.readOnly = true;
				            }
				        })
				    }
				}
				let dataResp = await dataService.getByTableName(this.tableName, this.dataId);
				if (dataResp.data.Status === "1") {
				    this.data = dataResp.data.Data || {};
					this.data = Object.assign(this.data, this.defaultValue)
					this.onLoad();
				}
			}else if (this.metaId || this.metaId == "0") {
				let resp = await fieldDescriptionService.getGridDescription(this.metaId);
				if (resp.data.Status === "1") {
				    this.descriptions = resp.data.Data.map(item => Object.assign(item, {readonly: item.readOnly})).filter(item =>!this.hiddenFields.some(ele=>ele===item.fieldName));
				    if (this.dataId){
				        this.descriptions.forEach(item => {
				            if(item.writeInCreation) {
				                item.readOnly = true;
				            }
				        })
				    }
				}
				let dataResp = await dataService.get(this.metaId, this.dataId);
				if (dataResp.data.Status === "1") {
				    this.data = dataResp.data.Data || {};
					this.data = Object.assign(this.data, this.defaultValue)
				}
			}
		},
        watch: {
			async data() {
				let value = this.data.customerId;
			    this.onchange(value)
			},
		},
        components: {
            Grid,
            [Button.name]: Button,
            [Toast.name]: Toast
        },
        computed: {
            groupedData: function () {
                return _.groupBy(this.descriptions, item => item.classify);
            }
        },
		mounted: async function() {
			
		},
        methods: {
			setValue(prop, value) {
				this.$set(this.data,prop,value)
			    //this.data[prop] = value;
			},
			async onLoad() {
				let res = await dataService.description(this.tableName);
				if (res.data.Status === "1") {
					if (res.data.Data){
						window.eval(res.data.Data)
						if(onload) {
							window.data = this.data;
							window.param = this.param;
							onload()
						}
					}
				}
			},
			async onchange(value) {
				let res = await dataService.description(this.tableName);
				if (res.data.Status === "1") {
					if (res.data.Data){
						window.eval(res.data.Data)
						if(onchange) {
							onchange(value)
						}
					}
				}
			},
            async save() {
				let flag = true;
				this.data = Object.assign(this.data, this.defaultValue);
				let requiredData = new Array();
				this.descriptions.forEach(item => {
				    if(item.required) {
				        requiredData.push(item.fieldName);
				    }
				})
				requiredData.forEach(item => {
				    if(!this.data[item]) {
				        Toast.fail('请填写必填项');
						flag = false;
						return;
				    }
				})
				if(flag) {
					if(this.tableName || this.tableName == "0") {
						let resp = await dataService.saveByTableName(this.tableName, this.data);
						if(resp.data.Status == "1") {
						    this.data.uuid = resp.data.Data;
						    Toast.success('保存成功');
							this.$emit('savecomplate',resp.data.Data)
						}else {
						    Toast.fail(resp.data.Message);
						}
					}else if (this.metaId || this.metaId == "0") {
						let resp = await dataService.save(this.metaId, this.data);
						if(resp.data.Status == "1") {
						    this.data.uuid = resp.data.Data;
						    Toast.success('保存成功');
							this.$emit('savecomplate',resp.data.Data)
						}else {
						    Toast.fail(resp.data.Message);
						}
					}
				}
            },
		}
    }
</script>
<style scoped>
    h2 {
        margin: 0;
        font-weight: 400;
        font-size: 1rem;
        color: rgba(69, 90, 100, .6);
        padding: 1rem 1rem 0.4rem;
    }
</style>